import { CALL_API } from '../middleware/api'

export const CUSTOMERS_REQUEST = 'CUSTOMERS_REQUEST'
export const CUSTOMERS_SUCCESS = 'CUSTOMERS_SUCCESS'
export const CUSTOMERS_FAILURE = 'CUSTOMERS_FAILURE'

export function fetchCustomers() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'customers',
      authenticated: true,
      types: [CUSTOMERS_REQUEST, CUSTOMERS_SUCCESS, CUSTOMERS_FAILURE]
    }
  }
}

export function fetchCustomersName() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'customers',
      authenticated: true,
      types: [CUSTOMERS_REQUEST, CUSTOMERS_SUCCESS, CUSTOMERS_FAILURE]
    }
  }
}

export const CUSTOMER_REQUEST = 'CUSTOMER_REQUEST'
export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS'
export const CUSTOMER_FAILURE = 'CUSTOMER_FAILURE'

export function fetchCustomer(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `customers/${id}`,
      authenticated: true,
      types: [CUSTOMER_REQUEST, CUSTOMER_SUCCESS, CUSTOMER_FAILURE]
    }
  }
}

export const CUSTOMER_ADD_REQUEST = 'CUSTOMER_ADD_REQUEST'
export const CUSTOMER_ADD_SUCCESS = 'CUSTOMER_ADD_SUCCESS'
export const CUSTOMER_ADD_FAILURE = 'CUSTOMER_ADD_FAILURE'

export function addCustomer(customer) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'customers',
      authenticated: true,
      body: JSON.stringify(customer),
      types: [CUSTOMER_ADD_REQUEST, CUSTOMER_ADD_SUCCESS, CUSTOMER_ADD_FAILURE]
    }
  }
}

export const CUSTOMER_UPDATE_REQUEST = 'CUSTOMER_UPDATE_REQUEST'
export const CUSTOMER_UPDATE_SUCCESS = 'CUSTOMER_UPDATE_SUCCESS'
export const CUSTOMER_UPDATE_FAILURE = 'CUSTOMER_UPDATE_FAILURE'

export function updateCustomer(id, props) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `customers/${id}`,
      authenticated: true,
      body: JSON.stringify(props),
      types: [CUSTOMER_UPDATE_REQUEST, CUSTOMER_UPDATE_SUCCESS,
              CUSTOMER_UPDATE_FAILURE]
    }
  }
}

export function updateClient(id, props) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `customers/client/${id}`,
      authenticated: false,
      body: JSON.stringify(props),
      types: [CUSTOMER_UPDATE_REQUEST, CUSTOMER_UPDATE_SUCCESS,
              CUSTOMER_UPDATE_FAILURE]
    }
  }
}

export const CUSTOMER_BLOCK_REQUEST = 'CUSTOMER_BLOCK_REQUEST'
export const CUSTOMER_BLOCK_SUCCESS = 'CUSTOMER_BLOCK_SUCCESS'
export const CUSTOMER_BLOCK_FAILURE = 'CUSTOMER_BLOCK_FAILURE'

export function blockCustomer(id) {
  return {
    [CALL_API]: {
      method: 'PATCH',
      endpoint: `customers/${id}/block`,
      authenticated: true,
      types: [CUSTOMER_BLOCK_REQUEST, CUSTOMER_BLOCK_SUCCESS,
              CUSTOMER_BLOCK_FAILURE]
    }
  }
}

export const CUSTOMER_RESET = 'CUSTOMER_RESET'

export function resetCustomer() {
  return { type: CUSTOMER_RESET }
}

export const DOWNLOAD_SAP_REQUEST = 'DOWNLOAD_SAP_REQUEST'
export const DOWNLOAD_SAP_SUCCESS = 'DOWNLOAD_SAP_SUCCESS'
export const DOWNLOAD_SAP_FAILURE = 'DOWNLOAD_SAP_FAILURE'

export function fetchSAPValues() {
  let params = ''

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `customers/sapvalues?${params}`,
      authenticated: true,
      types: [DOWNLOAD_SAP_REQUEST, DOWNLOAD_SAP_SUCCESS, DOWNLOAD_SAP_FAILURE]
    }
  }
}